
import Icon from '@/components/ui/AppIcon';

interface Resource {
  id: string;
  type: 'guide' | 'checklist' | 'calculator' | 'webinar';
  title: string;
  description: string;
  icon: string;
  downloadCount: string;
  cta: string;
}

const resources: Resource[] = [
  {
    id: 'compliance-checklist',
    type: 'checklist',
    title: 'HIPAA Compliance Checklist 2025',
    description: 'Comprehensive 47-point checklist ensuring full regulatory compliance',
    icon: 'ClipboardDocumentCheckIcon',
    downloadCount: '2,847',
    cta: 'Download Checklist'
  },
  {
    id: 'roi-calculator',
    type: 'calculator',
    title: 'Revenue Cycle ROI Calculator',
    description: 'Calculate potential revenue recovery from billing optimization',
    icon: 'CalculatorIcon',
    downloadCount: '1,923',
    cta: 'Use Calculator'
  },
  {
    id: 'credentialing-guide',
    type: 'guide',
    title: 'Medical Staff Credentialing Guide',
    description: '52-page comprehensive guide to streamlined credentialing processes',
    icon: 'BookOpenIcon',
    downloadCount: '3,156',
    cta: 'Download Guide'
  },
  {
    id: 'hcc-webinar',
    type: 'webinar',
    title: 'HCC Coding Mastery Webinar',
    description: 'On-demand training: Advanced risk adjustment strategies',
    icon: 'VideoCameraIcon',
    downloadCount: '1,542',
    cta: 'Watch Webinar'
  }
];

const getTypeColor = (type: string) => {
  switch (type) {
    case 'guide':
      return 'bg-primary/10 text-primary';
    case 'checklist':
      return 'bg-brand-success/10 text-brand-success';
    case 'calculator':
      return 'bg-accent/10 text-accent';
    case 'webinar':
      return 'bg-secondary/10 text-secondary';
    default:
      return 'bg-muted text-text-secondary';
  }
};

export default function ResourceCenter() {
  return (
    <section data-component-id="src/app/homepage/components/ResourceCenter.tsx:70:4" data-component-path="src/app/homepage/components/ResourceCenter.tsx" data-component-line="70" data-component-end-line="173" data-component-file="ResourceCenter.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-16%20lg%3Apy-24%20bg-white%22%7D" className="py-16 lg:py-24 bg-white">
      <div data-component-id="src/app/homepage/components/ResourceCenter.tsx:71:6" data-component-path="src/app/homepage/components/ResourceCenter.tsx" data-component-line="71" data-component-end-line="172" data-component-file="ResourceCenter.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Free Healthcare Resources & Tools
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Immediate value through expert-created resources, assessment tools, and educational content
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {resources.map((resource) => (
            <div
              key={resource.id}
              className="bg-surface p-6 rounded-xl border border-border hover:border-primary transition-medical hover-lift group"
            >
              <div className="mb-4">
                <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold mb-3 ${getTypeColor(resource.type)}`}>
                  {resource.type.charAt(0).toUpperCase() + resource.type.slice(1)}
                </div>
                <div className="w-14 h-14 bg-primary/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary transition-medical">
                  <Icon
                    name={resource.icon as any}
                    size={28}
                    className="text-primary group-hover:text-white transition-medical"
                    variant="solid"
                  />
                </div>
                <h3 className="text-lg font-bold text-text-primary mb-2">{resource.title}</h3>
                <p className="text-sm text-text-secondary mb-4">{resource.description}</p>
              </div>

              <div className="flex items-center justify-between pt-4 border-t border-border">
                <div className="flex items-center space-x-1 text-xs text-text-secondary">
                  <Icon name="ArrowDownTrayIcon" size={14} />
                  <span>{resource.downloadCount} downloads</span>
                </div>
                <button className="inline-flex items-center text-sm font-semibold text-primary hover:text-primary/80 transition-medical">
                  {resource.cta}
                  <Icon name="ArrowRightIcon" size={16} className="ml-1" />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-primary to-brand-authority rounded-2xl p-8 lg:p-12 text-white">
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl lg:text-3xl font-bold mb-4">
                Subscribe to Healthcare Excellence Insights
              </h3>
              <p className="text-white/90 mb-6">
                Weekly regulatory updates, operational best practices, and industry trends delivered to your inbox
              </p>
              <div className="flex items-center space-x-2 text-sm">
                <Icon name="CheckCircleIcon" size={20} className="text-brand-success" variant="solid" />
                <span>No spam, unsubscribe anytime</span>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6">
              <form className="space-y-4">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-text-primary mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="your.email@healthcare.org"
                    className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-text-primary"
                  />
                </div>
                <div>
                  <label htmlFor="role" className="block text-sm font-medium text-text-primary mb-2">
                    Your Role
                  </label>
                  <select
                    id="role"
                    className="w-full px-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-text-primary"
                  >
                    <option value="">Select your role</option>
                    <option value="administrator">Healthcare Administrator</option>
                    <option value="executive">Executive/C-Suite</option>
                    <option value="operations">Operations Manager</option>
                    <option value="compliance">Compliance Officer</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-primary text-white font-semibold rounded-lg hover:bg-primary/90 transition-medical flex items-center justify-center"
                >
                  <Icon name="EnvelopeIcon" size={20} className="mr-2" />
                  Subscribe Now
                </button>
              </form>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}